import {
  createContext,
  useContext,
  useEffect,
  useState,
  useMemo,
  useCallback,
} from "react";
import { useNavigate } from "react-router-dom";

const DataContext = createContext(null);

// my custom hook to use the DataContext
export const useAdminData = () => useContext(DataContext);

export function DataProvider({ children }) {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  const api = process.env.REACT_APP_API_URL;
  const fetchAdminData = useCallback(async () => {
    try {
      const res = await fetch(`${api}/adm/dashboard`, {
        credentials: "include",
      });
      if (res.status === 403) {
        navigate("/admin/login");
      }
      const data = await res.json();

      setBlogs(data.blogs);
      setMessages(data.messages);
    } catch (err) {
      setBlogs([]);
      setMessages([]);
      console.log("Error fetching admin data:", err);
    } finally {
      setLoading(false);
    }
  }, [api, navigate]);

  //fetch once
  useEffect(() => {
    fetchAdminData();
  }, [fetchAdminData]);

  // memoize res
  const loadingAndMessages = useMemo(() => {


    return {
       loading: loading ?? false,
      messages: messages ?? [],
      blogs: blogs ?? [],
      };
  }, [ loading, messages, blogs]);

  const value = {...loadingAndMessages,setLoading}

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
}
